import GameHeader from './GameHeader';

export default GameHeader;
